<template>
  <div class="main-layout">
    <el-card class="box-outter">
      <c-title slot="header" title="预报到时间设置" :back="false"></c-title>
      <el-card class="box-table box-inner" shadow="never">
        <div slot="header" class="btn-group">
          <!-- 操作按钮 -->
          <div class="btn-left">
            <div class="opt-btn" title="批量设置" @click="goto">
              <i class="iconfont icon-piliangshezhi"></i>
            </div>
          </div>
          <!-- 右侧操作按钮 -->
          <table-btns
            :tableColumns="tableColumns"
            @tableColumnsChange="tableColumnsChange"
            @refresh="pageGet(true)"
          ></table-btns>
        </div>
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
          @edit="goto"
        >
        </c-table>
      </el-card>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
          >
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/welcomeTime";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-forecast/forecast/listPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/welcome-forecast/forecast",
  handleInsertPath: "/welcome-forecast/forecast/save",
  handleUpdatePath: "/welcome-forecast/forecast/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      searchItems,
      tableColumns,
      defaultFormItems: formItems,
      formItems: [],
      formRules,
      idList: [],
      title: "",
      dialogFormVisible: false,
      defaultHandleData: {
        name: "",
        startTime: "",
        endTime: "",
        sort: "",
        isOpen: 1,
        academicDegree: [],
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {},
  mounted() {},
  methods: {
    handleBeforeFn(data) {
      let params = Object.assign({}, data);
      params.academicDegree = params.academicDegree.join();
      return params;
    },
    handleGetAfterFn(data) {
      data.academicDegree = data.academicDegree.split(",");
      return data;
    },
    goto(data) {
      this.handleData = Object.assign({}, this.defaultHandleData);

      let id = data.id;
      if (id) {
        this.formItems = [...this.defaultFormItems];
        this.handleGet(id);
        this.title = "编辑";
        this.dialogFormVisible = true;
      } else {
        if (this.idList.length) {
          this.formItems = this.defaultFormItems.slice(1);
          // this.handleData.name = "";
          this.title = "批量时间设置";
          this.dialogFormVisible = true;
        } else {
          this.$message({
            message: "请选择需要操作的事项！",
            type: "warning",
          });
        }
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        // this.handleInsert();
        this.batchUpdate();
      }
    },
    handleAfterFn() {
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.$refs.cForm.resetFields();
    },
    // 批量设置时间
    batchUpdate() {
      if (this.idList.length) {
        let params = {
          idList: this.idList,
          startTime: this.handleData.startTime,
          endTime: this.handleData.endTime,
          academicDegree: this.handleData.academicDegree.join(),
          isOpen: this.handleData.isOpen,
        };
        this.$http
          .post("/welcome-forecast/forecast/updateBatch", params)
          .then((res) => {
            console.log(res);
            if (res.code == this.SUCCESS_CODE) {
              // 清空idList
              this.idList = [];
              this.dialogFormVisible = false;
              this.pageGet(true);
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.success(err);
          });
      }
    },
  },
};
</script>
